/**
 * Supported languages in the application
 */
export type SupportedLanguage = 'en' | 'es' | 'pt'

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['en', 'es', 'pt']

export const isSupportedLanguage = (value: unknown): value is SupportedLanguage =>
  typeof value === 'string' && SUPPORTED_LANGUAGES.includes(value as SupportedLanguage)

/**
 * Resolves an arbitrary language value (cookie, profile field, navigator locale)
 * to a supported language code, or `null` when it names none.
 *
 * Accepts full locales (`en-US` → `en`) and discards garbage: lang cookies
 * written before the `setCookie` separator fix stored the cookie attributes
 * inside the value (`es expires=Fri, …`, or just `expires=Fri, …` when the
 * language was empty), which used to reach `Intl` APIs and throw.
 */
export const normalizeLanguage = (value?: string | null): SupportedLanguage | null => {
  const [candidate = ''] = (value || '').trim().split(' ')
  const lang = candidate.slice(0, 2).toLowerCase()

  return isSupportedLanguage(lang) ? lang : null
}
